module.exports = __webpack_public_path__ + "img/logo.8d7c1d29.png";